"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const __1 = require("../..");
const services_1 = require("../../../services");
function AlertOutlet({ multiple, name, reverseOrder, toastOutlet }) {
    const alertService = (0, services_1.useAlertService)();
    const [alerts, setAlerts] = (0, react_1.useState)([]);
    const [subscription, setSubscription] = (0, react_1.useState)();
    function receiveAlerts(receivedAlerts) {
        const newAlerts = [...receivedAlerts];
        if (reverseOrder)
            newAlerts.reverse();
        setAlerts(newAlerts);
    }
    function onAlertClose(alertIndex) {
        alertService.closeAlert(name, reverseOrder ? alerts.length - 1 - alertIndex : alertIndex);
    }
    // on load
    (0, react_1.useEffect)(() => {
        setSubscription(alertService
            .registerOutlet(name, multiple, toastOutlet)
            .subscribe(receiveAlerts));
        // on unload
        return () => {
            if (subscription) {
                subscription.unsubscribe();
                alertService.unregisterOutlet(name);
            }
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: alerts.length > 0 &&
            alerts.map(({ closable, content, fadeOut, heading, icon, role, slim, type, uuid }, index) => ((0, jsx_runtime_1.jsx)(__1.Alert, { fadeOut: fadeOut, heading: heading, icon: icon, role: role, slim: slim, type: type, onClose: closable ? () => onAlertClose(index) : undefined, children: content }, uuid))) }));
}
exports.default = AlertOutlet;
